import { InputProps } from './types';

export const deleteQuotes = ({ value }: InputProps): string => {
  const cleanString = value ? value.replaceAll('"', '') : '';
  return cleanString;
};
